export default theme => ({
  hexaSvg6: {
    position: 'absolute',
    top: 0,
    left: -50,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  hexaSvg7Container: {
    overflow: 'hidden',
    position: 'absolute',
    bottom: -90,
    right: 0,
    width: 322,
    height: 304,
  },
  hexaSvg7: {
    position: 'absolute',
    top: 0,
    right: -130,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  container: {
    backgroundColor: theme.palette.yellow.main,
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  titleContainer: {
    paddingBottom: theme.spacing(4),
    marginBottom: theme.spacing(4),
    borderBottom: '1px dotted #FFF',
  },
  title: {
    color: theme.palette.common.white,
    textAlign: 'center',
  },
  ficheGrid: {
    paddingBottom: theme.spacing(2),
  },
  ficheContainer: {
    marginBottom: theme.spacing(3),
  },
  ficheNum: {
    fontWeight: 300,
  },
  ficheTitle: {
    marginBottom: theme.spacing(1),
  },
});
